import i18n from 'i18next';
import detect from 'i18next-browser-languagedetector';
import { t } from 'i18next';
import { initReactI18next } from 'react-i18next';
/**
 * Initializes the i18next object. This loads translations via XHR from the
 * server at the location pub/locales/(language)/translation.json. This files
 * also adds a convenience t function globally.
 */
i18n
    .use(detect)
    .use(initReactI18next)
    .init({
    // debug: true,
    /**
     * Defines the JSON translation files for each languages. These
     * files will be embedded inside the app code because there are some
     * static translations that needs it.
     */
    resources: {
        en: {
            translation: require('../../../languages/locales/en/translation.json')
        },
        fr: {
            translation: require('../../../languages/locales/fr/translation.json')
        },
        es: {
            translation: require('../../../languages/locales/es/translation.json')
        }
    },
    /**
     * Uses english as the default language since all the string
     * are translated from english.
     */
    fallbackLng: 'en',
    /**
     * Disable the key separator because we're using string and not
     * keys as translation identifier.
     */
    keySeparator: false,
    /**
     * Do not escape translated values because this is already being
     * done by React.
     */
    interpolation: {
        escapeValue: false
    }
});
/**
 * Convenience global translation functions.
 * @since 1.0.0
 */
window.t = t;
export default i18n;
